import { App } from '@vivaldis/antd-ui'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSideSheetsHistory } from '../../SideSheets/hooks/useSideSheetsHistory'

export interface UseSideSheetConfirmationDialogParams {
  isConfirmationEnabled: boolean
}

export const useSideSheetConfirmationDialog = ({
  isConfirmationEnabled
}: UseSideSheetConfirmationDialogParams) => {
  const { t } = useTranslation('web_ui')
  const { modal } = App.useApp()
  const sideSheetsHistory = useSideSheetsHistory()

  useEffect(() => {
    if (isConfirmationEnabled) {
      if (sideSheetsHistory) {
        const unblock = sideSheetsHistory.block(tx => {
          // Navigation was blocked! Let's show a confirmation dialog
          // so the user can decide if they actually want to navigate
          // away and discard changes they've made in the current page.
          modal.confirm({
            title: t('side_sheet_confirmation_dialog.title'),
            content: t('side_sheet_confirmation_dialog.content'),
            cancelText: t('side_sheet_confirmation_dialog.cancel_text'),
            okText: t('side_sheet_confirmation_dialog.confirm_text'),
            onOk: async () => {
              // Unblock the navigation.
              unblock()

              // Retry the transition.
              tx.retry()
            },
            okType: 'danger'
          })
        })

        return () => {
          unblock()
        }
      }
    }
  }, [isConfirmationEnabled, modal, sideSheetsHistory, t])
}
